if (!customElements.get('cb-quick-menu')) {
  customElements.define('cb-quick-menu', class extends HTMLElement {
    connectedCallback() {
      this.abort?.abort();
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      const details = this.querySelector('details');
      const toggle = this.querySelector('summary');
      const link = this.querySelector('.cb-quick-menu__link');
      const firstLink = () => this.querySelector('.cb-quick-menu__panel a');
      const close = () => { details.open = false; };
      this.addEventListener('pointerenter', (event) => {
        if (event.pointerType === 'mouse' && this.classList.contains('cb-quick-menu--desktop') && matchMedia('(hover: hover)').matches) details.open = true;
      }, options);
      this.addEventListener('pointerleave', (event) => {
        if (event.pointerType === 'mouse' && this.classList.contains('cb-quick-menu--desktop')) close();
      }, options);
      this.addEventListener('focusout', (event) => {
        if (!this.contains(event.relatedTarget)) close();
      }, options);
      this.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && details.open) {
          event.preventDefault();
          event.stopPropagation();
          close();
          toggle.focus();
        } else if (event.key === 'ArrowDown' && (event.target === link || event.target === toggle)) {
          event.preventDefault();
          details.open = true;
          firstLink()?.focus();
        }
      }, options);
      document.addEventListener('pointerdown', (event) => {
        if (!this.contains(event.target)) close();
      }, options);
      details.addEventListener('toggle', () => {
        toggle.setAttribute('aria-label', `${details.open ? 'Sbalit' : 'Rozbalit'} nabídku ${link.textContent.trim()}`);
      }, options);
    }
    disconnectedCallback() { this.abort?.abort(); }
  });
}
